<template>
  <asc-card flat class="asc-fleet-sort-card" no-spacing>
    <div
      :class="[
        'asc-fleet-sort-card--content',
        active ? 'asc-fleet-sort-card--active' : '',
      ]"
      @click="handleClick"
      @mouseover="isHovering = true"
      @mouseout="isHovering = false"
    >
      <div class="asc-fleet-sort-card--count">
        <asc-label size="xxxxl" :value="count"></asc-label>
      </div>
      <div class="asc-fleet-sort-card--title">
        <asc-label size="md" :value="title" uppercase></asc-label>
      </div>
      <div class="asc-fleet-sort-card--sort">
        <div class="asc-fleet-sort-card--sort-container">
          <asc-label
            :color="getSortColor"
            size="md"
            value="Sort Tails"
            uppercase
          ></asc-label>
          <template v-if="active">
            <v-icon class="asc-fleet-sort-card--active-icon" size="18">{{
              getSortIcon
            }}</v-icon>
          </template>
          <template v-if="getDisplaySortIconOnHover">
            <v-icon class="asc-fleet-sort-card--hover-icon" size="18">{{
              getSortIcon
            }}</v-icon>
          </template>
        </div>
      </div>
    </div>
  </asc-card>
</template>

<script>
import AscCard from '../atoms/AscCard.vue'
import AscLabel from '../atoms/AscLabel.vue'

import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscFleetSortCard',

  components: {
    AscCard,
    AscLabel,
  },

  props: {
    count: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    sortIndex: {
      type: Number,
      default: 0,
    },
    onClick: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      sortOrder: '',
      isHovering: false,
    }
  },

  computed: {
    getSortColor() {
      return variables.accent700
    },

    getDisplaySortIconOnHover() {
      if (this.active) {
        return false
      }

      return this.isHovering
    },

    getIssuesColor() {
      return this.item.issuesCount > 0
        ? variables.warningbase
        : variables.gray500
    },

    getFaultMessagesColor() {
      return this.item.fdeCount > 0 ? variables.warningbase : variables.gray500
    },

    getWifiColor() {
      return this.item.daysOffline < 3
        ? variables.gray500
        : variables.warningbase
    },

    getSortIcon() {
      return 'mdi-arrow-down'
    },
  },

  watch: {
    active(newValue) {
      if (this.active !== newValue) {
        this.sortOrder = ''
      }
    },
  },

  methods: {
    handleClick() {
      if (this.onClick) {
        this.sortOrder =
          this.sortOrder === 'asc' || this.sortOrder === '' ? 'desc' : 'asc'
        this.onClick(this.sortIndex, this.sortOrder)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-fleet-sort-card {
  margin-bottom: 16px;
  width: 150px;
  height: 135px;

  &:hover {
    cursor: pointer;

    .asc-fleet-sort-card--sort-container {
      .asc-label {
        text-decoration: underline;
      }
    }
  }

  &--content {
    height: 100%;
    border: 1px solid $gray-400;
    padding: 8px 4px;
    text-align: center;
    width: 100%;

    .asc-fleet-sort-card--sort {
      position: absolute;
      bottom: 8px;
      left: 0;
      right: 0;
      width: 100%;

      .asc-fleet-sort-card--sort-container {
        display: flex;
        justify-content: center;

        .asc-fleet-sort-card--active-icon {
          color: $primary-black;
        }
      }
    }
  }

  .asc-card__text {
    height: 100%;
  }

  &--active {
    background-color: $accent-0;
  }
}
</style>
